// FeeProtectorList.jsx
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Datatable from '../../ExtraComponents/ReusableTable2';
import ReactPaginate from "react-paginate";
import { getAllFeeProtector, runComparisonApi } from '../../Service/FeeProtector/FeeProtectorService';
import sweetalert2 from 'sweetalert2';
import debounce from 'lodash.debounce';
import Swal from "sweetalert2";
import { DateConvert, DateConvertWithTime, cleanHtmlEntities, roundNumber } from "../../Utils/CommonFun";

import { downloadContract } from "../../ReduxStore/Slice/Contract/contractSlice";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Settings, PanelTop, Wrench, GitCompare, Eye } from "lucide-react";
import * as Config from "../../Utils/Config";


const STATUS_LABELS = {
  due_for_review: "Due for Review",
  overdue: "Overdue",
  threshold_breach: "Threshold Breach",
  completedContract: "Successful Fee Gap Closure",
  renewal_completed: "No Action Required",
};

const FeeProtectorList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // URL se status param lo
  const queryParams = new URLSearchParams(location.search);
  const statusFilter = queryParams.get("status") || "";
  console.log("statusFilter", statusFilter);

  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const user_id = JSON.parse(localStorage.getItem("details"))?.id;

  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [InputValue, setInputValue] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isLoading, setLoading] = useState(false);

  console.log("totalRecords", totalRecords);

  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])

  const formatNumber = (num) => {
    if (num === null || num === undefined) return null;
    return new Intl.NumberFormat("en-GB").format(Number(num));
  };



  const [feeProtectorData, setFeeProtectorData] = useState([]);

  const debounceSearch = useCallback(
    debounce((value) => setDebouncedSearch(value), 500), []
  );

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    debounceSearch(e.target.value);
  };

  useEffect(() => { setCurrentPage(1); }, [InputValue]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await getAllFeeProtector({
        agent_id,
        user_id,
        page: currentPage,
        limit: pageSize,
        search: debouncedSearch,
        status: statusFilter,   // ✅ status filter pass
      });
      setFeeProtectorData(res?.data ?? []);
      setTotalRecords(res?.pagination?.total);
      // setTotalRecords(res?.pagination?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => { fetchData(); }, [currentPage, pageSize, debouncedSearch]);

  let columns = [

    {
      name: "Client",
      width: "10%",
      selector: (row) => row?.Client?.client_name,

      sortFunction: (a, b) => {
        const nameA = (a?.Client?.client_name || "").toLowerCase();
        const nameB = (b?.Client?.client_name || "").toLowerCase();

        return nameA.localeCompare(nameB);
      },
      cell: (row) => <span style={{ fontSize: '13px' }}
        onClick={() => navigate("/admin/ViewFeeProtector", { state: row })}
      >
        {cleanHtmlEntities(row?.Client?.client_name) ?? "-"}
      </span>,
      sortable: true,
    },
    {
      name: "Client Manager",
      width: "14%",
      selector: (row) => row?.Client?.am_name,
      sortFunction: (a, b) => {
        const nameA = (a?.Client?.am_name || "").toLowerCase();
        const nameB = (b?.Client?.am_name || "").toLowerCase();

        return nameA.localeCompare(nameB);
      },
      cell: (row) => <span style={{ fontSize: '13px' }}
        onClick={() => navigate("/admin/ViewFeeProtector", { state: row })}
      >
        {row?.Client?.am_name ?? "-"}
      </span>,
      sortable: true,
    },
    // {
    //   name: "VAT",
    //   width: "100px",
    //   selector: (row) => {
    //     const vat = row?.Client?.FeeProtectorDriverValues?.[0]?.vatregistered;

    //     return vat === "Yes"
    //       ? "VAT"
    //       : vat === "No"
    //         ? "NON-VAT"
    //         : "-";
    //   },
    // },
    {
      name: "Status",
      width: "13%",
      selector: (row) => row?.statusFeeProtector,
      sortFunction: (a, b) => {
        const valA = (a?.statusFeeProtector || "").toLowerCase().trim();
        const valB = (b?.statusFeeProtector || "").toLowerCase().trim();

        return valA.localeCompare(valB);
      },
      cell: (row) => (
        <span className={`badge ${row?.statusColor || ""}`}
          onClick={() => navigate("/admin/ViewFeeProtector", { state: row })}
        >
          {row?.statusFeeProtector || "-"}
        </span>
      ),
      sortable: true,
    },

    {
      name: "Current Fee",
      width: "13%",
      selector: (row) => row?.total_monthly_excluding_ongoing || 0,
      sortable: true,
      sortFunction: (a, b) => {
        const valA = Number(a?.total_monthly_excluding_ongoing || 0);
        const valB = Number(b?.total_monthly_excluding_ongoing || 0);
        return valA - valB;
      },

      cell: (row) => (
        <span onClick={() => navigate("/admin/ViewFeeProtector", { state: row })}>
          £{roundNumber(row?.total_monthly_excluding_ongoing || 0)}
          /{row?.frequencyCode_ongoing || "-"}
        </span>
      ),
    },
    {
      name: "Proposed Fee",
      width: "15%",
      selector: (row) => row?.total_monthly_excluding_ongoing_new || 0,
      sortFunction: (a, b) => {
        const valA = Number(a?.total_monthly_excluding_ongoing_new || 0);
        const valB = Number(b?.total_monthly_excluding_ongoing_new || 0);
        return valA - valB;
      },
      cell: (row) =>
        row?.finalDriverData?.length === 0 ?
          <span
            onClick={() => navigate("/admin/ViewFeeProtector", { state: row })}
          > - </span>
          :
          <span className="red fee-gap-col"
            onClick={() => navigate("/admin/ViewFeeProtector", { state: row })}
          >
            +£{roundNumber(row?.total_monthly_excluding_ongoing_new) + "/" + row?.frequencyCode_ongoing}
          </span>,
      sortable: true,
    },
    {
      name: "Fee Gap",
      width: "13%",
      selector: (row) => row?.total_monthly_excluding_ongoing_new - row?.total_monthly_excluding_ongoing || 0,
      sortFunction: (a, b) => {
        const valA = Number(a?.total_monthly_excluding_ongoing_new - a?.total_monthly_excluding_ongoing || 0);
        const valB = Number(b?.total_monthly_excluding_ongoing_new - b?.total_monthly_excluding_ongoing || 0);
        return valA - valB;
      },
      cell: (row) =>
        row?.finalDriverData?.length === 0 ?
          <span
            onClick={() => navigate("/admin/ViewFeeProtector", { state: row })}
          > - </span>
          :
          <span className="red fee-gap-col"
            onClick={() => navigate("/admin/ViewFeeProtector", { state: row })}
          >
            +£{roundNumber(roundNumber(row?.total_monthly_excluding_ongoing_new) - roundNumber(row?.total_monthly_excluding_ongoing)) + "/" + row?.frequencyCode_ongoing + " (" + row?.percentageIncrease_ongoing + "%)"}
          </span>,
      sortable: true,
    },

    {
      name: "Next Review",
      width: "12%",
      selector: (row) => row.nextReview,
      sortable: true,
      sortFunction: (a, b) => {
        const dateA = new Date(a?.nextReview || 0).getTime();
        const dateB = new Date(b?.nextReview || 0).getTime();
        return dateA - dateB;
      },
    },
    {
      name: "Actions",
      width: "10%",
      center: true,
      cell: (row) => (
        <div className="actions"
          style={{ marginLeft: "12px" }}>

          <a
            onClick={() =>
              runComparison(row?.Client?.id, row?.id)
            }
          >
            <GitCompare size={15} />
          </a>

          <a
            style={{ fontWeight: "bold" }}
            onClick={() =>
              navigate("/admin/ViewFeeProtector", {
                state: row,
              })
            }
          >
            <Eye size={14} strokeWidth={3} />
          </a>
        </div>
      ),
    },
  ];


  if (statusFilter === "completedContract") {
    columns = [
      {
        name: "Subject",
        selector: (row) => row?.subject == null || row?.subject == "" ? "-" : row?.subject,
        sortable: true,
      },
      {
        name: "Client",
        selector: (row) => row?.Client?.client_name,
        sortFunction: (a, b) => {
          const nameA = (a?.Client?.client_name || "").toLowerCase();
          const nameB = (b?.Client?.client_name || "").toLowerCase();

          return nameA.localeCompare(nameB);
        },
        sortable: true,
      },
      {
        name: "Created On",
        selector: row => row.createdAt,
        cell: row => DateConvertWithTime(row.createdAt),
        sortable: true,
        sortFunction: (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      },

      {
        name: "Status",
        selector: (row) => {
          const contractSigned = Number(row?.contract_signed);
          const status = Number(row?.status);
          const step = Number(row?.step);

          if (contractSigned === 1) {
            return "Contract Signed";
          }

          if (status === 4) {
            return "Contract Declined";
          }

          if (status === 3) {
            return "Contract Reviewed";
          }

          if (step === 4) {
            return "Contract Sent";
          }


          if (step !== 4 && status !== 4) {
            if (Number(row?.higher_discount_status) === 0 && Number(row?.request_higher_discount_ongoing) === 1) {
              return "Requested Higher Discount";
            }
            else if (Number(row?.higher_discount_status_oneoff) === 0 && Number(row?.request_higher_discount_oneoff) === 1) {
              return "Requested Higher Discount";
            }
            else if (Number(row?.higher_discount_status) === 1 || Number(row?.higher_discount_status_oneoff) === 1) {
              return "Discount Approved";
            }
            else if (Number(row?.higher_discount_status) === 2 || Number(row?.higher_discount_status_oneoff) === 2) {
              return "Discount Rejected";
            }
            else {
              return "In Progress";
            }
          }

          return "-";
        },
        sortable: true,
      },
      {
        name: "Action",
        selector: (row) => (
          <div>
            {/* Download/Convert Button */}
            <button
              className="btn fs-4 py-0 px-1"
              onClick={() => handleConvert(row)}
              title="Download Document"
            >
              <i className="ri-download-2-line" />
            </button>

          </div>
        ),
        sortable: true,
      },
    ];

  }



  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  if (statusFilter === "renewal_completed") {
    columns = [
      {
        name: "Subject",
        selector: (row) => row?.subject == null || row?.subject == "" ? "-" : row?.subject,
        sortable: true,
      },
      {
        name: "Client",
        selector: (row) => row?.Client?.client_name,
        sortFunction: (a, b) => {
          const nameA = (a?.Client?.client_name || "").toLowerCase();
          const nameB = (b?.Client?.client_name || "").toLowerCase();

          return nameA.localeCompare(nameB);
        },
        sortable: true,
      },
      {
        name: "Created On",
        selector: row => row.createdAt,
        cell: row => DateConvertWithTime(row.createdAt),
        sortable: true,
        sortFunction: (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      },

      {
        name: "Status",
        selector: (row) => {
          const contractSigned = Number(row?.contract_signed);
          const status = Number(row?.status);
          const step = Number(row?.step);

          if (contractSigned === 1) {
            //  return "Contract Signed";
            return "Contract Renewed";
          }

          if (status === 4) {
            return "Contract Declined";
          }

          if (status === 3) {
            return "Contract Reviewed";
          }

          if (step === 4) {
            return "Contract Sent";
          }

          return "-";
        },
        sortable: true,
      },

      {
        name: "Reason",
        selector: (row) => row?.reason_text || "-",
        cell: (row) => (
          <div className="reason-show-container">
            <p className="reason-show" title={row?.reason_text}>
              {row?.reason_text || "-"}
            </p>
          </div>
        ),
        sortFunction: (a, b) =>
          (a?.reason_text || "")
            .toLowerCase()
            .localeCompare((b?.reason_text || "").toLowerCase()),
        sortable: true,
      },
      {
        name: "Action",
        selector: (row) => (
          <div>
            {/* preview button */}
            <button
              className="btn fs-4 py-0 px-1 border-0"
              onClick={() => handlePreview(row)}
              //  onClick={(e) => {
              //   e.stopPropagation(); //
              //   setSelectedReason(row?.reason_text || "No reason available.");
              //   setShowReasonModal(true);
              // }}
              title="Preview Contract"
            >
              <i className="ri-eye-line"></i>
            </button>


            {/* Download/Convert Button */}
            <button
              className="btn fs-4 py-0 px-1 border-0"
              onClick={() => handleConvert(row)}
              title="Download Document"
            >
              <i className="ri-download-2-line" />
            </button>

          </div>
        ),
        sortable: true,
      },
    ]
  }


  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);


  const [previewModal, setPreviewModal] = useState(false);
  const handlePreview = async (row) => {
    try {
      if (!row?.pendingId || !row?.orignalId) {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "Please complete the contract first",
        });
        return;
      }

      let req = {
        agent_id: agent_id,
        id: row?.id,
      };

      const response = await dispatch(downloadContract(req)).unwrap();

      if (response.status) {
        const access_token = response.data;

        setLoading(true);

        const pdfResponse = await axios.get(
          `https://api.signeasy.com/v3/rs/envelope/signed/${row.pendingId}/${row.orignalId}/download`,
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
            responseType: "blob",
          }
        );

        const blob = new Blob([pdfResponse.data], {
          type: "application/pdf",
        });

        const url = URL.createObjectURL(blob);

        setPdfUrl(url);
        setShowPdfModal(true);

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const handleConvert = async (row) => {

    if (!row?.pendingId || !row?.orignalId || !row?.access_token) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please complete the contract first",

        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
      });
      return;
    }

    let req = { agent_id: agent_id, id: row?.id };
    await dispatch(downloadContract(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          // console.log("response.data-->>",response)
          let access_token = response.data

          // let access_token = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjdMLXZ0VDNiN2pYc2I2cUZjLVBhNyJ9.eyJodHRwczovL3NpZ25lYXN5LmNvbS9lbWFpbCI6ImVzaWduQG5vbWlzbWFzb2x1dGlvbi5jby51ayIsImh0dHBzOi8vc2lnbmVhc3kuY29tL3VzZXJfaWQiOiI1MjUxNDc2IiwiaHR0cHM6Ly9zaWduZWFzeS5jb20vdGVzdF9tb2RlIjoiMSIsImlzcyI6Imh0dHBzOi8vYXV0aC5zaWduZWFzeS5jb20vIiwic3ViIjoidHdhZHRTZTN1ckU5cWZETUVlU0N0eHFudnk1dklzNHhAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vYXBpLWV4dC5zaWduZWFzeS5jb20vIiwiaWF0IjoxNzY1ODAyMTM4LCJleHAiOjE3NjgzOTQxMzgsInNjb3BlIjoidXNlcjpyZWFkIGZpbGVzOnJlYWQgb3JpZ2luYWw6cmVhZCBvcmlnaW5hbDpjcmVhdGUgb3JpZ2luYWw6dXBkYXRlIHNpZ25lZDpyZWFkIHNpZ25lZDpjcmVhdGUgc2lnbmVkOnVwZGF0ZSByczpyZWFkIHJzOmNyZWF0ZSByczp1cGRhdGUgcnM6c2lnbmluZ3VybCB0ZW1wbGF0ZTptYW5hZ2Ugd2ViaG9va3M6bWFuYWdlIiwiZ3R5IjoiY2xpZW50LWNyZWRlbnRpYWxzIiwiYXpwIjoidHdhZHRTZTN1ckU5cWZETUVlU0N0eHFudnk1dklzNHgifQ.RfQwxVSP-TV6zMN6Uo1NmhFvZOIg1dgAL3Cp0bV_1GKG9LxWT7bxGH6hirTlMfboOuIT-_vZ4qDt3LgdpF6B9RazaV-enFqEkV_EBdh5iTe26_t12vRWaI04X6AOnpIYd5D-I136tkUhw3-7cziIqxH48ATFtvL_ti8BTknPnhSkRYxJzaPN2wQYat2w4Bnfp7zFDIIBtEm5ixFlTfzoOEsU-UtIRif0yACej_KT9rrQcvhWJfq5QrLzkySCkks4Lao88_7_SO64XCRPkqjJLfmD3sJciN74qzwW9zsoS_RKXtgNaueNIKfu2p_t3tHmrwubCgEmpCsjd11EEkIi1A"

          setLoading(true);
          let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `https://api.signeasy.com/v3/rs/envelope/signed/${row.pendingId}/${row.orignalId}/download`,
            headers: {
              //Authorization: "Bearer " + row?.access_token,
              Authorization: "Bearer " + access_token,
            },
            responseType: "blob", // Important for binary PDF
          };

          axios
            .request(config)
            .then((response) => {
              setLoading(false);
              const blob = new Blob([response.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `${row.subject || "document"}.pdf`;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              setLoading(false);

              console.log("Download error:", error);
            });


        } else {

        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  const runComparison = (client_id, contract_id) => {

    sweetalert2.fire({
      title: "Run Comparison",
      text: "Are you sure you want to run comparison for this contract?",
      showCancelButton: true,
      confirmButtonText: "Yes, Run Comparison",
      cancelButtonText: "No, Cancel",
      customClass: {
        popup: 'my-swal-height',
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const data = {
            agent_id: agent_id,
            user_id: user_id,
            client_id: client_id,
            contract_id: contract_id,
          };
          setLoading(true);
          const res = await runComparisonApi(data);
          if (res?.status === true) {

            setTotalRecords(0);
            setCurrentPage(1);
            setPageSize(10);
            setInputValue('');
            setDebouncedSearch('');
            // sweetalert2.fire({
            //   title: "Run Comparison",
            //   text: "Comparison has been successfully run.",
            //   icon: "success",
            //   showConfirmButton: false,
            //   timer: 3000,
            // })
            // return
            Swal.close();
            setLoading(false);
            setTimeout(() => {
              Swal.fire({
                title: "Run Comparison",
                text: "Comparison has been successfully run.",
                icon: "success",
                showConfirmButton: false,
                timer: 3000,
                didClose: async () => {
                  setLoading(true);
                  try {
                    await fetchData();
                  } finally {
                    setLoading(false);
                  }
                }
              });
            }, 200);

          } else {
            setLoading(false);
            sweetalert2.fire({
              icon: "error",
              title: "Error",
              text: res?.message
            })
          }


        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      }
    })
  }



  //// Export Files
  const handleExport = async () => {
    setLoading(true);
    let totalData = feeProtectorData;

    const data = {
      agent_id: agent_id,
      user_id: user_id,
      page: 1,
      limit: 100000,
      search: debouncedSearch,
      status: statusFilter,
    };
    setLoading(true);
    const response = await getAllFeeProtector(data);
    totalData = response?.data ?? []


    if (totalData.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      setLoading(false);
      return
    }


    let formattedData = response?.data?.map((row) => ({

      "CLIENT": row?.Client?.client_name || "-",
      "CLIENT MANAGER": row?.Client?.am_name || "-",
      "STATUS": row?.statusFeeProtector || "-",
      "CURRENT FEE": roundNumber(Number(row?.total_monthly_excluding_ongoing || 0)),
      "CURRENT FEE FREQUENCY": row?.frequencyCode_ongoing || "-",
      "PROPOSED FEE": row?.finalDriverData?.length === 0
        ? "-"
        : roundNumber(Number(row?.total_monthly_excluding_ongoing_new || 0)),
      "PROPOSED FEE FREQUENCY": row?.frequencyCode_ongoing || "-",
      "FEE GAP":
        row?.finalDriverData?.length === 0
          ? "-"
          : roundNumber(
            roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
            roundNumber(row?.total_monthly_excluding_ongoing || 0)
          ),

      "FEE GAP FREQUENCY": row?.frequencyCode_ongoing || "-",
      "FEE GAP PERCENTAGE (%)": row?.finalDriverData?.length === 0 ? "-" : row?.percentageIncrease_ongoing || 0,

      "ANNUAL FEE GAP": roundNumber(
          row?.frequencyCodeNumber_ongoing *
          (
            roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
            roundNumber(row?.total_monthly_excluding_ongoing || 0)
          )
      ),
      "ANNUAL FEE GAP FREQUENCY": row?.frequencyCode_ongoing || "-",
      "ANNUAL FEE GAP PERCENTAGE (%)": row?.finalDriverData?.length === 0 ? "-" : row?.percentageIncrease_ongoing || 0,
      "NEXT REVIEW": row?.nextReview || "-",

      // "DRIVERS":
      //   row?.driverOrder
      //     ?.filter((d) => d && d?.value?.trim() !== "")
      //     ?.map((d) => d?.value)
      //     ?.join(", ") || "-",


    }));


    if (statusFilter === "completedContract") {

      formattedData = response?.data?.map((row) => ({
        "Subject": row?.subject,
        "Client": row?.Client?.client_name,
        "Created On": DateConvertWithTime(row?.createdAt),
        "Status": Number(row?.contract_signed) === 1 ? "Contract Signed" :
          Number(row?.status) === 3 ? "Awaiting Signature" :
            Number(row?.step) === 4 ? "Pending for Signature" :
              Number(row?.step) !== 4 ? "In Progress" :
                "-",
      }));

    }

    if (statusFilter === "renewal_completed") {

      formattedData = response?.data?.map((row) => ({
        "Subject": row?.subject,
        "Client": row?.Client?.client_name,
        "Created On": DateConvertWithTime(row?.createdAt),
        "Status": Number(row?.contract_signed) === 1 ? "Contract Renewed" :
          Number(row?.status) === 3 ? "Awaiting Signature" :
            Number(row?.step) === 4 ? "Pending for Signature" :
              Number(row?.step) !== 4 ? "In Progress" :
                "-",
        "Reason": row?.reason_text
      }));
    }





    setLoading(false);
    downloadCSV(formattedData, STATUS_LABELS[statusFilter] + ".csv");
  };

  const downloadCSV = (data, filename) => {
    if (!data || !data.length) return;
    const headers = Object.keys(data[0]);
    const csvRows = [];
    // HEADER
    csvRows.push(headers.join(","));
    // BODY
    data.forEach((row) => {
      const values = headers.map((header) => {
        let value = row[header] ?? "";
        // double quotes escape
        value = String(value).replace(/"/g, '""');
        return `"${value}"`;
      });
      csvRows.push(values.join(","));
    });
    const csvString = csvRows.join("\n");
    // UTF-8 BOM ADD
    const csvWithBom = "\uFEFF" + csvString;
    const blob = new Blob(
      [csvWithBom],
      {
        type: "text/csv;charset=utf-8;",
      }
    );
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleExportPDF = async () => {
    setLoading(true);
    let totalData = feeProtectorData;

    const data = {
      agent_id: agent_id,
      user_id: user_id,
      page: 1,
      limit: 100000,
      search: debouncedSearch,
      status: statusFilter,
    };
    setLoading(true);

    const response = await getAllFeeProtector(data);
    totalData = response?.data ?? []


    if (!response?.status || response?.data?.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      setLoading(false);
      return;
    }
    let type = "feeProtector";
    let formattedData = response?.data?.map((row) => ({

      "Client": row?.Client?.client_name || "-",
      "Client Manager": row?.Client?.am_name || "-",
      "Status": row?.statusFeeProtector || "-",
      "Current Fee": roundNumber(Number(row?.total_monthly_excluding_ongoing || 0)),
      "Proposed Fee": row?.finalDriverData?.length === 0
        ? "-"
        : roundNumber(Number(row?.total_monthly_excluding_ongoing_new || 0)),
      "Fee Gap":
        row?.finalDriverData?.length === 0
          ? "-"
          : roundNumber(
            roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
            roundNumber(row?.total_monthly_excluding_ongoing || 0)
          ),

      "Annual Fee Gap": roundNumber(
          row?.frequencyCodeNumber_ongoing *
          (
            roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
            roundNumber(row?.total_monthly_excluding_ongoing || 0)
          )
      ),
      "Frequency": row?.frequencyCode_ongoing || "-",
      "Percentage (%)": row?.finalDriverData?.length === 0 ? "-" : row?.percentageIncrease_ongoing || 0,
      "Next Review": row?.nextReview || "-",

    }));

    if (statusFilter === "completedContract") {
      type = "completedContract";
      formattedData = response?.data?.map((row) => ({
        "Subject": row?.subject,
        "Client": row?.Client?.client_name,
        "Created On": DateConvertWithTime(row?.createdAt),
        "Status": Number(row?.contract_signed) === 1 ? "Contract Signed" :
          Number(row?.status) === 3 ? "Awaiting Signature" :
            Number(row?.step) === 4 ? "Pending for Signature" :
              Number(row?.step) !== 4 ? "In Progress" :
                "-",
      }));

    }

    else if (statusFilter === "renewal_completed") {
      type = "renewal_completed";
      formattedData = response?.data?.map((row) => ({
        "Subject": row?.subject,
        "Client": row?.Client?.client_name,
        "Created On": DateConvertWithTime(row?.createdAt),
        "Status": Number(row?.contract_signed) === 1 ? "Contract Renewed" :
          Number(row?.status) === 3 ? "Awaiting Signature" :
            Number(row?.step) === 4 ? "Pending for Signature" :
              Number(row?.step) !== 4 ? "In Progress" :
                "-",
        "Reason": row?.reason_text
      }));
    }







    const res = await axios.post(
      Config.base_url + "export-contract-pdf",
      { data: formattedData, type: type },
      { responseType: "blob" }
    );

    setLoading(false);

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = STATUS_LABELS[statusFilter] + ".pdf";
    a.click();
  };

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: { popup: "no-shadow" },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  const showPagination = pageSize !== 0 && Math.ceil(totalRecords / pageSize)

  return (
    <div className="config-setting-container">
      <section className="section">
        <div>
          <div className="Protector-header justify-content-between"
            style={{ display: "flex", alignItems: "center", gap: "12px" }}
          >

            <div>
              <h4 className='page-title' style={{ fontSize: '24px' }}>
                Fee Protector — {STATUS_LABELS[statusFilter] || "All"}
              </h4>
            </div>

            <button onClick={() => navigate("/admin/feeprotector")} className="btn btn-sm btn-outline-secondary">
              ← Back
            </button>

          </div>

          <div className="d-flex align-items-center justify-content-between mb-3 gap-2">
            <div className="search-box">
              <input
                type="text"
                value={InputValue}
                onChange={handleInputChange}
                placeholder="Search clients..."
              />
            </div>
            <div>

              {feeProtectorData?.length > 0 && (
                <>
                  <button className="btn-outline-pink btn me-2" onClick={handleExportPDF}>
                    <i className="ri-download-2-line"></i> Export PDF
                  </button>

                  <button className="btn-outline-pink btn me-2"
                    onClick={handleExport}
                  >
                    <i className="ri-download-2-line"></i>  Export CSV
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="quote-table">
            <Datatable
              columns={columns}
              data={feeProtectorData}
              filter={false}
              // onRowClicked={(row) => navigate("/admin/ViewFeeProtector", { state: row })}
              onRowClicked={
                ["completedContract", "renewal_completed"].includes(statusFilter)
                  ? undefined
                  : (row) =>
                    navigate("/admin/ViewFeeProtector", {
                      state: row,
                    })
              }
            />

            {feeProtectorData?.length > 0 && (
              <div>
                {
                  showPagination > 1 && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  )
                }


                <div className="mt-0">
                  <select
                    // className="perpage-select"
                    className={showPagination > 1 ? "perpage-select" : "perpage-select mt-3 mb-3"}
                    value={pageSize}
                    onChange={handlePageSizeChange}
                  >
                    {/* <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option> */}
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={0}>ALL</option>
                  </select>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {showPdfModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">PDF Preview</h5>

                {/* Open in New Tab Button */}
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-pink ms-2 btn-sm"
                  style={{ fontSize: '10px' }}
                >
                  Open in New Tab
                </a>

                {/* Close Button */}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPdfModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <iframe
                  src={pdfUrl}
                  title="PDF Preview"
                  width="100%"
                  height="600px"
                  style={{ border: "none" }}
                />
              </div>
            </div>
          </div>
        </div>

      )}




      {showReasonModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Reason</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowReasonModal(false)}
                />
              </div>

              <div className="modal-body">
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    background: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    borderRadius: "6px",
                    padding: "15px",
                    maxHeight: "450px",
                    overflowY: "auto",
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  {selectedReason || "No reason available"}
                </pre>
              </div>

            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default FeeProtectorList;